"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dft2 = exports.dft1 = exports.documentMetadata = void 0;
exports.documentMetadata = [
    {
        patientMrn: null,
        dateOfService: 1655769600000,
        providerNumber: "1223566",
        placerOrderNumber: "RAD_PHS_CHG_012-ec0b0f5137b04a419a57af069252a255",
        fillerOrderNumber: "E54fbcfc4be38400cb846dc73705a2abe",
        encounterNumber: "VISIT-b10657ebae57496eb50bafa4bd2acd24-2022-06-21-DAA49",
        uniqueDocumentNumber: "",
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "RADIOLOGY",
        documentCategory: "DFT_OUT",
        messageCategory: null,
        documentStatus: "FINAL",
        documentName: "dft1.txt",
        documentDescription: null,
        mimeType: "text/plain",
        contentLength: 669,
        externalId: "C-24969-2",
        documentGuid: {
            uuid: "3ac43fb6-0cd5-4474-a5a2-6fe7e15ca18d"
        },
        documentId: 52528,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: null,
        additionalInfo: null,
        hl7MessageType: null,
        hl7MessageDirection: null,
        id: 52528,
        specialty: ""
    },
    {
        patientMrn: null,
        dateOfService: 1655769600000,
        uniqueDocumentNumber: "",
        providerNumber: "1223566",
        placerOrderNumber: "RAD_PHS_CHG_012-ec0b0f5137b04a419a57af069252a255",
        fillerOrderNumber: "E54fbcfc4be38400cb846dc73705a2abe",
        encounterNumber: "VISIT-b10657ebae57496eb50bafa4bd2acd24-2022-06-21-DAA49",
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "RADIOLOGY",
        documentCategory: "DFT_OUT",
        messageCategory: null,
        documentStatus: "FINAL",
        documentName: "dft1.txt",
        documentDescription: null,
        mimeType: "text/plain",
        contentLength: 669,
        externalId: "C-24969-1",
        documentGuid: {
            uuid: "22b83b40-4299-46fe-8a04-98a647b7ebc3"
        },
        documentId: 52527,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: null,
        additionalInfo: null,
        hl7MessageType: null,
        hl7MessageDirection: null,
        id: 52527,
        specialty: ""
    },
    {
        patientMrn: "00cf5d8db75243fc991030e2ac62895e",
        dateOfService: 1655769600000,
        providerNumber: "1703383",
        uniqueDocumentNumber: "",
        placerOrderNumber: "RAD_PHS_CHG_012-ec0b0f5137b04a419a57af069252a255",
        fillerOrderNumber: "E54fbcfc4be38400cb846dc73705a2abe",
        encounterNumber: "VISIT-b10657ebae57496eb50bafa4bd2acd24-2022-06-21-DAA49",
        encounterGuid: {
            uuid: "f789246b-629e-4a1d-9eb9-2ea66f842b7e"
        },
        observationRequestGuid: {
            uuid: "5b3b8cd4-3dec-44b4-bccf-04841656d54c"
        },
        observationResultGuid: {
            uuid: "5c9c98d0-6510-4894-a1af-d6d5fc48ae91"
        },
        documentType: "RADIOLOGY",
        documentCategory: "NOTE",
        messageCategory: null,
        documentStatus: "FINAL",
        documentName: null,
        documentDescription: null,
        mimeType: "text/plain",
        contentLength: 1313,
        externalId: "8f8e4db2d07a4917a7d880c0b44011dc",
        documentGuid: {
            uuid: "c3daf3a7-1f2e-490e-8a2f-9865f1b97661"
        },
        documentId: 52524,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: null,
        additionalInfo: null,
        hl7MessageType: null,
        hl7MessageDirection: null,
        id: 52524,
        specialty: ""
    },
    {
        patientMrn: "",
        dateOfService: 1655769600000,
        providerNumber: "DAA49",
        uniqueDocumentNumber: "",
        placerOrderNumber: "RAD_PHS_CHG_012-ec0b0f5137b04a419a57af069252a255",
        fillerOrderNumber: "E54fbcfc4be38400cb846dc73705a2abe",
        encounterNumber: "",
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "RADIOLOGY",
        documentCategory: "HL7",
        messageCategory: null,
        documentStatus: "FINAL",
        documentName: "oru1.txt",
        documentDescription: null,
        mimeType: "text/plain",
        contentLength: 6664,
        externalId: "8f8e4db2d07a4917a7d880c0b44011dc",
        documentGuid: {
            uuid: "9f1cc1f3-ebec-433f-a5fc-8e423b171e57"
        },
        documentId: 52523,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: null,
        additionalInfo: null,
        hl7MessageType: null,
        hl7MessageDirection: null,
        id: 52523,
        specialty: ""
    }
];
exports.dft1 = {
    Note: "MSH|^~\\&|ICM|ICMPB RADNCH|PB|PHS|20220624005101||DFT^P03|C-24969-2|T|2.3\r\nPID|1||00cf5d8db75243fc991030e2ac62895e^^^EPIC^PMRN||RADPHSCHG012455^Demo^^^^^L||19411108000000|F\r\nPV1|1|OUTPATIENT|||||1703383^DONTCHOS^BRIAN^^^^^^EPIC^^^^EPIC|1223566^ANDELLOUX^DEREK^^^^^^EPIC^^^^EPIC|||||||||||VISIT-b10657ebae57496eb50bafa4bd2acd24^^^EPIC^VN|||||||||||||||||||||||||||\r\nFT1|1|CMX-P118075|C21659|20220621142146||CG|77066|||1|||NCH_NCHIMGBI^^139||||||N64.4^^I10|1824828^CAVALLO HOM^KATHERINE^^^^^^EPIC^^^^EPIC|1703383^DONTCHOS^BRIAN^^^^^^EPIC^^^^EPIC||RAD_PHS_CHG_012-ec0b0f5137b04a419a57af069252a255|||ACT|\r\nNTE|1||E54fbcfc4be38400cb846dc73705a2abe\r\nZFT|||||||||||||||BI1NCH\r\n"
};
exports.dft2 = {
    Note: "MSH|^~\\&|ICM|ICMPB RADNCH|PB|PHS|20220624005101||DFT^P03|C-24969-1|T|2.3\r\nPID|1||00cf5d8db75243fc991030e2ac62895e^^^EPIC^PMRN||RADPHSCHG012455^Demo^^^^^L||19411108000000|F\r\nPV1|1|OUTPATIENT|||||1703383^DONTCHOS^BRIAN^^^^^^EPIC^^^^EPIC|1223566^ANDELLOUX^DEREK^^^^^^EPIC^^^^EPIC|||||||||||VISIT-b10657ebae57496eb50bafa4bd2acd24^^^EPIC^VN|||||||||||||||||||||||||||\r\nFT1|1|CMX-P118074|C21659|20220621142146||CG|77062|||1|||NCH_NCHIMGBI^^139||||||N64.4^^I10|1824828^CAVALLO HOM^KATHERINE^^^^^^EPIC^^^^EPIC|1703383^DONTCHOS^BRIAN^^^^^^EPIC^^^^EPIC||RAD_PHS_CHG_012-ec0b0f5137b04a419a57af069252a255|||ACT|\r\nNTE|1||E54fbcfc4be38400cb846dc73705a2abe\r\nZFT|||||||||||||||BI1NCH\r\n"
};
//# sourceMappingURL=including-dfts.js.map